// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteButton_deleteButton__1fExS","deleteIcon":"DeleteButton_deleteIcon__4apCP"};